var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_vm._v("2020-2025 © 团子翻译器")])}
var staticRenderFns = []

export { render, staticRenderFns }